module.exports = __webpack_public_path__ + "img/revenues-Import.0811ae71.png";